import { FlashAuto } from "@mui/icons-material";
import { GET_SETTLEMENTLIST, GET_SETTLEMENTDETAILS, GET_ADDSETTLEMENT, GET_UPDATESETTLEMENT, GET_CONSOLIDATEDINVOICE } from "resources/actionTypes";

const initialSettlementList = {
  loading: false,
  error : null,
  settlementList : '',
};

const initialSettlementDetails = {
  loading: false,
  error: null,
  settlementDetails : '',
}

const initialState = {
  loading : false,
  error: null,
  settlementResponse: '',
}

const initialUpdateSettlement = {
  loading: false,
  error : null,
  updateSettlement: '',
}

const initialConsolidatedInvoice = {
  loading: false,
  error : null,
  consolidatedInvoiceData : '',
};

export const getSettlementList = (
  state = initialSettlementList, action
) => {
  switch(action.type){
    case GET_SETTLEMENTLIST.GET_SETTLEMENTLIST_REQUESTED:
      return{
        ...state,
        loading: true,
      };
      case GET_SETTLEMENTLIST.GET_SETTLEMENTLIST_SUCCESS:
        return {
          ...state,
          loading: false,
          settlementList: action.settlementList
        }
      case GET_SETTLEMENTLIST.GET_SETTLEMENTLIST_FAILED:
        return {
          ...state,
          loading: false,
          error: action.message,
        };
      default:
        return state;
  }
}


export const getSettlementDetails = (
  state = initialSettlementDetails,
  action
) => {
  switch (action.type) {
    case GET_SETTLEMENTDETAILS.GET_SETTLEMENTDETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_SETTLEMENTDETAILS.GET_SETTLEMENTDETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        settlementDetails: action.settlementDetails,
      };
    case GET_SETTLEMENTDETAILS.GET_SETTLEMENTDETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};


export const addSettlement = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADDSETTLEMENT.GET_ADDSETTLEMENT_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDSETTLEMENT.GET_ADDSETTLEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        settlementResponse: action.settlementResponse,
      };
    case GET_ADDSETTLEMENT.GET_ADDSETTLEMENT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};


export const updateSettlement = (state = initialUpdateSettlement, action) => {
  switch (action.type) {
    case GET_UPDATESETTLEMENT.GET_UPDATESETTLEMENT_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATESETTLEMENT.GET_UPDATESETTLEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_UPDATESETTLEMENT.GET_UPDATESETTLEMENT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getConsolidateInvoiveList = (
  state = initialConsolidatedInvoice, action
) => {
  switch(action.type){
    case GET_CONSOLIDATEDINVOICE.GET_CONSOLIDATEDINVOICE_REQUESTED:
      return{
        ...state,
        loading: true,
      };
      case GET_CONSOLIDATEDINVOICE.GET_CONSOLIDATEDINVOICE_SUCCESS:
        return {
          ...state,
          loading: false,
          consolidatedInvoiceData: action.consolidatedData
        }
      case GET_CONSOLIDATEDINVOICE.GET_CONSOLIDATEDINVOICE_FAILED:
        return {
          ...state,
          loading: false,
          error: action.message,
        };
      default:
        return state;
  }
}